import { FC } from 'react';
import { useParams, useRouteMatch } from 'react-router-dom';
import {
  TRANCHE_ADD_REDESIGN,
  TRANCHE_EDIT_REDESIGN,
} from 'adminConstants/routes';
import api from 'lib/trpcClient';
import { QUERY_STALE_TIME_MS } from 'further-ui/config';
import TrancheFormV1 from './v1';
import TrancheFormV2 from './v2';

const TrancheForm: FC = () => {
  const { id } = useParams<{ id?: string }>();
  const isEditRedesign = useRouteMatch(TRANCHE_EDIT_REDESIGN);
  const isAddRedesign = useRouteMatch(TRANCHE_ADD_REDESIGN);
  const isRedesign = isEditRedesign ?? isAddRedesign;
  const { data: tranche, isLoading: isLoadingTranche } = api.fund.get.useQuery(
    { id: id ?? '' },
    {
      enabled: !!id,
      staleTime: QUERY_STALE_TIME_MS,
      suspense: Boolean(isRedesign && id),
    },
  );

  if (isRedesign) {
    return <TrancheFormV2 tranche={tranche} />;
  }

  return (
    <TrancheFormV1 tranche={tranche} isLoadingTranche={isLoadingTranche} />
  );
};

export default TrancheForm;
